import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider as UrqlProvider } from 'urql'
import { gqlClient } from './lib/gql.js'
import App from './App.js'
import { GuestRealtimeProvider } from './components/GuestRealtimeProvider.js'
import { applyTheme, readTheme } from './lib/theme.js'
import './styles.css'
// Modo estadio: reglas colgadas de html[data-modo="estadio"] y clases st-* (sin efecto fuera del modo).
import './stadium.css'

// Aplica el tema elegido ANTES del render (evita el flash de tema al cargar).
applyTheme(readTheme())

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <UrqlProvider value={gqlClient}>
        <BrowserRouter>
          <GuestRealtimeProvider>
            <App />
          </GuestRealtimeProvider>
        </BrowserRouter>
      </UrqlProvider>
    </QueryClientProvider>
  </React.StrictMode>,
)
